import { useSuspensionInfoFacade } from './useSuspensionInfoFacade';
import { useAddOns, useBillingAccount, usePlanDetail } from '../queries';

const DEFAULT_INCLUDE_PURCHASED = true;

export const useAddOnsFacade = (
  planId: number | null | undefined,
  includePurchased = DEFAULT_INCLUDE_PURCHASED,
  planGroupIdOverride?: number
) => {
  const planDetail = usePlanDetail();

  const suspensionData = useSuspensionInfoFacade().data;
  const preSuspendPlanGroupId = suspensionData?.getPreSuspendPlanGroupId();
  const preSuspendPlanId = suspensionData?.getPreSuspendPlanId();
  /**
   * Priority order for plan group ID:
   * 1. preSuspendPlanGroupId — suspended users always use their pre-suspend group
   * 2. planGroupIdOverride — callers can supply an override (e.g. paid Micro Email
   *    users viewing group 109 plans that differ from their own group 379)
   * 3. planDetail planGroupId — default for all other users
   */
  const planGroupId = planGroupIdOverride ?? preSuspendPlanGroupId ?? planDetail.data?.getPlanGroupId();
  const finalPlanId = planGroupIdOverride != null ? planId : preSuspendPlanId ?? planId;

  const billingAccountQuery = useBillingAccount();
  const currencyCode = billingAccountQuery.data?.getCurrency();

  const addOnsQuery = useAddOns(
    typeof planGroupId === 'number' &&
      typeof finalPlanId === 'number' &&
      finalPlanId !== -1 &&
      typeof currencyCode === 'string'
      ? {
          planGroupId,
          planId: finalPlanId,
          currencyCode,
          includePurchased,
        }
      : null
  );

  return addOnsQuery;
};
